export const tagClassMap: Record<string, string> = {
  截图: "bg-primary-100 text-primary-700",
  截图证据: "bg-primary-100 text-primary-700",
  录音: "bg-accent-100 text-accent-800",
  录音文件: "bg-accent-100 text-accent-800",
  文件: "bg-secondary-100 text-secondary-800",
  文档材料: "bg-secondary-100 text-secondary-800",
  线索: "bg-accent-100 text-accent-800",
  线索整理: "bg-accent-100 text-accent-800",
  对比: "bg-secondary-100 text-secondary-800",
  交叉验证: "bg-secondary-100 text-secondary-800",
  投稿: "bg-primary-100 text-primary-700",
  网友投稿: "bg-primary-100 text-primary-700",
  汇总: "bg-background-200 text-foreground-700",
  本周重点: "bg-primary-500 text-background-50",
};

export const tagFallbackClass = "bg-background-200 text-foreground-700";

export function tagClass(tag: string): string {
  return tagClassMap[tag] ?? tagFallbackClass;
}